import { forwardRef, useCallback } from "react";
import { ReviewCarousel } from "../ReviewCarousel";
import { useInView } from "../hooks/useInView";
import "./Testimonials.css";

const Testimonials = forwardRef((props, ref) => {
  const [inViewRef, isInView] = useInView({ threshold: 0.15 });
  const setRef = useCallback(
    (el) => {
      inViewRef.current = el;
      if (typeof ref === "function") ref(el);
      else if (ref) ref.current = el;
    },
    [ref, inViewRef]
  );

  return (
    <div
      className={`container testimonials-section ${isInView ? "testimonials-in-view" : ""}`}
      ref={setRef}
    >
      {/* Enhanced header section */}
      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <h2 style={{
          color: "#755673",
          marginBottom: "12px",
          fontSize: "2.5rem",
          fontWeight: 700,
          letterSpacing: "0.5px",
          fontFamily: '"Lora", "Times New Roman", serif',
        }}>
          What Our Clients Say
        </h2>
        <p style={{
          color: "#666",
          fontSize: "18px",
          fontStyle: "italic",
          margin: 0,
          maxWidth: "600px",
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: "1.6",
        }}>
          Real experiences from those who have found peace and healing through energy cleansing
        </p>
        <p
          style={{
            color: "#755673",
            fontSize: "14px",
            fontWeight: 600,
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            marginTop: "16px",
            marginBottom: 0,
            opacity: 0.85,
          }}
        >
          Trusted by clients across Ireland
        </p>
      </div>

      <div
        style={{
          width: "100%",
          maxWidth: "1350px",
          margin: "0 auto 40px",
          overflow: "visible",
          position: "relative",
        }}
      >
        <ReviewCarousel />
      </div>
    </div>
  );
});

export default Testimonials;
